export const categoryColors = {
	Shopping: '#b3dfcc',
	Taxes: '#22336e',
	Transportation: '#3a55ad',
	Travel: '#4969d0',
	Utilities: '#6e8ff7',
	Healthcare: '#95afff',
	'Gifts & Donations': '#a7bdff',
	Education: '#a40000',
	'Food & Dining': '#d81f1f',
	Housing: '#f23a3a',
	Insurance: '#fe7373',
	'Personal Care': '#79d3ac',
	Entertainment: '#52b289',
	Other: '#ffb4b4',
	Business: '#277e59',
};

export const fallbackCategoryColor = '#cccccc';
